import * as yup from "yup";
const yupTypeValidator = (item) => {

  const requiredMsg = `${item.FieldTitle} es obligatorio`;

  if (item.HtmlType === "selectobj" || item.HtmlType === "radioobj") {
    return yup.string().label(item.FieldTitle).required(requiredMsg);
  } else if (item.HtmlType === "select" || item.HtmlType === "radio") {
    return yup.string().label(item.FieldTitle).required(requiredMsg);
  } else
    // MODIFICADO: Agregado .startsWith("varchar(") para manejar varchar(100), varchar(50), etc.
    if (item.FieldType === "string" || 
        item.FieldType === "varchar" || 
        item.FieldType.startsWith("varchar(") || 
        item.FieldType === "datetime") {
      return yup.string().label(item.FieldTitle).required(requiredMsg);
    } else if (item.FieldType === "bool" || item.FieldType === "bit") {
      return yup.boolean().label(item.FieldTitle).required(requiredMsg);
    } else if (item.FieldType === "int" || item.FieldType === "bigint" || item.FieldType === "decimal" || item.FieldType === "money") {
      return yup.number().label(item.FieldTitle).required(requiredMsg);
    } else if (item.FieldType === "date") {
      return yup.date().label(item.FieldTitle).required(requiredMsg);
    }
};

export default yupTypeValidator;